import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { LabsComponent } from '@app/components/apps/Labs&Research/LabComponent';
import { NominalPaymentsComponent } from '@app/components/apps/NominalPayments/NominalPaymentsComponent';

export const EditNominalPayment: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Nominal Payment Task');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    { path: '/nominal-payments', breadcrumbName: 'Nominal Payments' },
    { path: '/edit-nominal-payment', breadcrumbName: currentBreadcrumName },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <NominalPaymentsComponent
          type={'edit'}
          editable={false}
          id={id}
          pageTitle={`Edit Nominal Payment Task`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default EditNominalPayment;
